import { useQuery } from "react-query";
import API from "../../axios/API";
import { QUERY_KEYS } from "../keys";
import { GET_ENDPOINTS } from "@/axios/API/endpoints";

const getTeamLocations = async (teamId) => {
  const { data } = await API.get(`${GET_ENDPOINTS.TEAM_LOCATIONS}${teamId}`);
  return data.locations;
};

const useAllTeamLocations = (teamId) =>
  useQuery([QUERY_KEYS.TEAM_LOCATIONS, teamId], () => getTeamLocations(teamId));

export default useAllTeamLocations;
